<template>
  <section :class="$style.container">
    <Wrapper :class="$style.inner">
      <div :class="$style.header">
        <Title :title-params="primary.title" :class="$style.title" />
        <RichText
          :text-params="primary.description"
          :class="$style.description"
        />
      </div>
      <div :class="$style.body">
        <Accordion
          v-for="(item, itemIndex) in items"
          :key="itemIndex"
          :item-index="itemIndex"
          :item="item"
          :class="$style.accordion"
          :active-item="activeItem"
          @select="onSelect"
        />
      </div>
    </Wrapper>
  </section>
</template>

<script>
import Title from '~/components/Title'
import RichText from '~/components/RichText'
import { getFormatedLink } from '~/mixins/getFormatedLink'

import Accordion from './components/Accordion'

export default {
  name: 'Faq',

  components: {
    Title,
    RichText,
    Accordion,
  },

  mixins: [getFormatedLink],

  props: {
    slice: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      primary: this.slice.primary,
      items: this.slice.items,
      activeItem: null,
    }
  },

  methods: {
    onSelect({ itemIndex, isHidden }) {
      if (isHidden) {
        this.activeItem = null
      } else {
        this.activeItem = itemIndex
      }
    },
  },
}
</script>

<style lang="scss" module>
.container {
  padding: 128px 24px;
}
.header {
  max-width: 720px;
  margin: 0 auto;
}
.body {
  max-width: 840px;
  margin: 40px auto 0;
}
.title {
  font-weight: 200;
  font-size: 48px;
  line-height: 56px;
  text-align: center;
}
.description {
  @include typo-body;
  color: $gray-700;
  text-align: center;
}
.accordion {
  margin-top: 8px;
  &:first-of-type {
    margin-top: 0;
  }
}
</style>
